import { combineReducers } from 'redux';
import { produce } from 'immer';

export const frontReducer = (state = null, action) => {
    switch (action.type) {
        case 'GET_POST_LOAD':
            let prevoiusposts = state.posts;
            let updated_value = prevoiusposts.concat(action.payload.value);
            //This will avoid duplicates
            //let standardsList = updated_value.filter((li, idx, self) => self.map(itm => itm.id).indexOf(li.id) === idx);
            return {
                ...state,
                loading: false,
                [action.payload.id]: updated_value
            }

        case 'SET_SINGLE_LOAD':
            return {
                ...state,
                loading: false,
                [action.payload.id]: action.payload.value
            }

        case 'GET_FRONT_SETTING':
            return {
                ...state,
                loading: false,
                ...action.payload
            }

        case 'GET_FRONT_ERRORS':
            return {
                ...state,
                loading: false,
                criticalError: action.errorMsg,
                ...action.payload
            }

        case 'UPDATE_FRONT_SETTING':
            return {
                ...state,
                loading: false,
                [action.payload.id]: action.payload.value
            }

        case 'UPDATE_FRONT_DRAFT':
            return produce(state, draft => {
                draft[`${action.payload.id}`][`${action.payload.externalId}`][`${action.payload.internalId}`] = action.payload.value;
            });

        case 'UPDATE_SINGLE_DRAFT':
            return produce(state, draft => {
                draft[`${action.payload.externalId}`][`${action.payload.internalId}`] = action.payload.value;
            });

        case 'UPDATE_DRAFT':
            return produce(state, draft => {
                draft[`${action.payload.internalId}`] = action.payload.value;
            });

        case 'GET_JUDGE_DATA':
            return {
                ...state,
                loading: false,
                judging_data: action.payload,
            };

        default:
            return state;

    }
}

export default combineReducers({
    wpvcfrontdata: frontReducer
});
